import React from 'react';
import { PlaceholderBlock } from '../../styled/placeholders.styled';

export const ButtonPlaceholder = () => (
  <PlaceholderBlock width="73px" height="44px" borderRadius="14px" margin="0" />
);
